 
 export  const calculateEnrollmentPercentage = (cohort: any) => {
   if(!cohort) return 'nil'
    const { numberOfEnrolled, numberOfParticipants } = cohort;
    // Handle division by zero
    if (numberOfParticipants === 0) {
      return "0%";
    }
    // Calculate the percentage
    let enrollmentPercentage = (numberOfEnrolled / numberOfParticipants) * 100;
  
    // Round to 2 decimal places (optional)
     enrollmentPercentage = Math.ceil(Math.round(enrollmentPercentage * 100) / 100);
    return `${enrollmentPercentage}%`;
  }
  

  export const calculateCompletionPercentage = (cohort: any) => {
    if(!cohort) return 'nil'
    const { completed, numberOfParticipants } = cohort;
    // Handle division by zero
    if (numberOfParticipants === 0) {
      return "0%";
    }
    // Calculate the percentage
    let completionPercentage = (completed / numberOfParticipants) * 100;
    // Round to 2 decimal places (optional)
    completionPercentage = Math.ceil(Math.round(completionPercentage * 100) / 100);
    return `${completionPercentage || 0}%`;
  };
  
  export const calculateActionPlanCompletionPercentage = (cohort: any) => {
    if(!cohort) return 'nil'
    const { numberOfCompletedAchievements, numberOfSubmittedGoals } = cohort;
    // Handle division by zero
    if (numberOfSubmittedGoals === 0) {
      return "0%";
    }
    // Calculate the percentage
    let completionPercentage = (numberOfCompletedAchievements / numberOfSubmittedGoals) * 100;
    // Round to 2 decimal places (optional)
    completionPercentage = Math.ceil(Math.round(completionPercentage * 100) / 100);
    return `${completionPercentage}%`;
  };

  export const calculateCohortsPercentage = (cohorts: any[]) => {
      if(!cohorts) return 'nil'
        const calculateCompletionPercentage = (completed: number, total: number) => {
            return total === 0 ? 0 : Math.round((completed / total) * 100);
        };
        const generateContentString = (cohorts: any) => {
            return cohorts.map((cohort: any) => {
                const percentage = calculateCompletionPercentage(cohort.completed, cohort.numberOfParticipants);
                return `•${cohort.name}: ${percentage}%`;
            }).join('\\n');
       };
    return generateContentString(cohorts);
  }